export default __webpack_public_path__ + "static/media/arrow-back.3996769d.svg";